<div class="view-saved-pin-main-container">
    <div class="header-container-view-saved-pin">
    <h1 mat-dialog-title class="view-saved-pin-header">{{ 'VIEW-SAVE-PIN-DIALOG.TITLE' | translate }}</h1>
</div>
<form [formGroup]="viewSavedPinForm">

    <div class="view-saved-pin-input-container">
        <mat-form-field class="view-saved-pin-input" appearance="outline"  style="width: 180px;">
            <mat-label>{{'VIEW-SAVE-PIN-DIALOG.PIN-TYPE' | translate }}</mat-label>
            <mat-select formControlName="pinType" style="width: 140px;" (selectionChange)="setSelectedPinType($event)">
                <mat-select-trigger>
                    <span style="display: flex;flex-direction: row;align-items: center;">
                        <img src="{{'../../assets/icons/' + (pinType?.id ? pinIcons[pinType.id] : 'new_pin_updated.png')}}" alt="New Pin Icon" class="pin-icon" style="margin-top: -3px;">
                        <span>{{pinType?.name}}</span>
                    </span>
                </mat-select-trigger>
                <mat-option *ngFor="let pinType of pinTypesList" [value]="pinType">
                    <span style="display: flex;flex-direction: row;align-items: center">
                        <img src="{{'../../assets/icons/' + (pinType?.id ? pinIcons[pinType.id] : 'new_pin_updated.png')}}" alt="New Pin Icon" class="pin-icon">
                        <span>{{pinType.name}}</span>
                    </span>
                </mat-option>
            </mat-select>
            <!--        <mat-error *ngIf="newOrderForm.get('cropId').invalid && newOrderForm.get('cropId').touched" class="error-notice">-->
            <!--            <strong class="item-required-text">Required* - </strong> Select a crop-->
            <!--        </mat-error>-->

        </mat-form-field>

        <app-date-range-selector (periodSelected)="handlePeriodSelection($event)" style="width: 180px; margin-left:10px;"></app-date-range-selector>
    </div>


    <div class="filter-datepicker-container" *ngIf="isCustomRange">

        <mat-form-field appearance="outline" class="" style="width: 180px;">
            <mat-label>Start date</mat-label>
            <input matInput formControlName="filterStartDate" [max]="viewSavedPinForm.get('filterEndDate').value" [matDatepicker]="pickerStart" (click)="setFilterDates()" placeholder="Start">           
            <mat-datepicker-toggle matIconSuffix [for]="pickerStart"></mat-datepicker-toggle>
            <mat-datepicker #pickerStart></mat-datepicker>
          </mat-form-field>

          <mat-form-field appearance="outline" class="" style="width: 180px; margin-left:10px;">
            <mat-label>End date</mat-label>
            <input matInput  formControlName="filterEndDate"  [min]="viewSavedPinForm.get('filterStartDate').value" [matDatepicker]="pickerEnd"  (click)="setFilterDates()" placeholder="End date">
            <mat-datepicker-toggle matIconSuffix [for]="pickerEnd"></mat-datepicker-toggle>
            <mat-datepicker #pickerEnd></mat-datepicker>
          </mat-form-field>
    </div>

</form>
<div mat-dialog-actions style="flex-wrap: nowrap;">
    <button mat-flat-button (click)="cancel()" type="button"
        class="cancel-view-saved-pin">{{'VIEW-SAVE-PIN-DIALOG.CANCEL' | translate }}</button>
    <button class="view-saved-pin-delete-btn" mat-flat-button
        (click)="clear()">{{'VIEW-SAVE-PIN-DIALOG.CLEAR' | translate }}</button>
    <button class="view-saved-pin-save-btn" mat-flat-button
        (click)="apply()">{{'VIEW-SAVE-PIN-DIALOG.APPLY' | translate }}</button>
</div>
</div>